import DashboardLayout from '../components/DashboardLayout';
import ProfileForm from '../components/ProfileForm';
import ProfilePictureUploader from '../components/ProfilePictureUploader';

const IdentityPage = () => (
  <DashboardLayout title="Identity settings">
    <div className="section">
      <div className="card hero-card">
        <span className="eyebrow">Identity</span>
        <h3 style={{ margin: '0.4rem 0' }}>Keep your profile current</h3>
        <p style={{ color: 'var(--dark)', marginBottom: '0.5rem' }}>
          Update your profile data and profile picture to ensure apps using Gate.haus have the most accurate details.
        </p>
        <p style={{ color: 'var(--gray)', margin: 0 }}>
          Changes sync immediately across connected Gate.haus applications.
        </p>
      </div>
      <div className="dashboard-grid" style={{ alignItems: 'start' }}>
        <ProfileForm />
        <ProfilePictureUploader />
      </div>
    </div>
  </DashboardLayout>
);

export default IdentityPage;
